import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerificationLinkStateService {
  private readonly LOCAL_STORAGE_KEY = 'isMailVerified';
  private readonly SESSION_STORAGE_KEY = 'isMailVerifiedSession';
  private readonly COOKIE_NAME = 'isMailVerified';
  constructor() { }

  setMailVerified(status: boolean) {
    localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(status));
    sessionStorage.setItem(this.SESSION_STORAGE_KEY, JSON.stringify(status));
  }

  getMailVerified(): boolean {
    const sessionStatus = sessionStorage.getItem(this.SESSION_STORAGE_KEY);
    if (sessionStatus) {
      return JSON.parse(sessionStatus);
    }
    const localStatus = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (localStatus) {
      sessionStorage.setItem(this.SESSION_STORAGE_KEY, localStatus);
      return JSON.parse(localStatus);
    }
    return false;
  }

  resetMailVerified() {
    localStorage.removeItem(this.LOCAL_STORAGE_KEY);
    sessionStorage.removeItem(this.SESSION_STORAGE_KEY);
  }
}
